import { EmploymentType, Therapist } from 'types/types';

interface Params {
  therapist: Therapist;
}

export const isTherapistFullTime = ({ therapist }: Params): boolean =>
  therapist.employmentType === EmploymentType.FullTime;
